import { useRootStore } from "~/store/root"

export default defineNuxtPlugin(async () => {
    useRootStore().getAnonymousId(true)
})
